import React, { useEffect } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { MDBCol, MDBRow } from "mdbreact";
import { Input, Label } from "abs-ui-components";
import {
	INPUT_STEP_VALUE,
	preventScientificNotation,
	roundOff,
} from "../../../services/utilities";

const WapsFormGroup = (props) => {
	const { control, setValue, trigger, setError,
		formState: { errors },
		clearErrors, } = useFormContext();

	// Handle blur event for input fields
	const handleBlur = async (field, value) => {
		if (!isNaN(value)) {
			if (+value > 0) {
				setValue(field, roundOff(value));
			}
		} else {
			return null;
		}
		await trigger(field);
	};
	useEffect(() => {
		if (props?.pprop !== undefined) {
			const pprop = props?.pprop
				? roundOff(props?.pprop)
				: "";
			setValue(
				`vesselAttributes.pprop`,
				pprop
			);

			if (
				props?.regulations?.trim() !== "EUMRV" &&
				props?.regulations?.trim() !== "UKMRV" &&
				props?.regulations?.trim() !== "DCS"
			) {
				if (pprop === 0) {
					setError(
						"vesselAttributes.pprop",
						{
							type: "manual",
							message: "Please enter a value greater than zero.",
						}
					);
				} else {
					clearErrors(
						"vesselAttributes.pprop"
					);
				}
			}
		}

		if (props?.pwind !== undefined) {
			const pwind = props?.pwind
				? roundOff(props?.pwind)
				: "";
			setValue(
				`vesselAttributes.pwind`,
				pwind
			);

			if (
				props?.regulations?.trim() !== "EUMRV" &&
				props?.regulations?.trim() !== "UKMRV" &&
				props?.regulations?.trim() !== "DCS"
			) {
				if (pwind === 0) {
					setError(
						"vesselAttributes.pwind",
						{
							type: "manual",
							message: "Please enter a value greater than zero.",
						}
					);
				} else {
					clearErrors(
						"vesselAttributes.pwind"
					);
				}
			}
		}
	}, [
		props.imoBasedData,
		setValue,
		props.pwind,
		props.pprop,
		setError,
		clearErrors,
		props.regulations,
	]);

	return (
		<>
			<div className="container-fluid p-0 m-0">
				<MDBRow>
					<MDBCol md="12" className="mt-3">
						<Label
							bold
							name="P(wind), wind-assisted propulsion effective power (kW)"
							className="mb-1"
						/>
						<Controller
							name="vesselAttributes.pwind"
							control={control}
							defaultValue={
								props.vesselMstId &&
									props.vesselData?.Pwind !== null &&
									props.vesselData?.Pwind !== undefined
									? roundOff(props.vesselData.Pwind)
									: ""
							}

							render={({ field }) => (
								<Input
									id="vessel_wind"
									autoFocus={false}
									value={field.value}
									onChange={field.onChange}
									type="number"
									className="input-height"
									step={INPUT_STEP_VALUE}
									onBlur={(e) =>
										handleBlur(field.name, field.value)
									}
									onKeyDown={(e) => {
										preventScientificNotation(e);
										// Prevent up and down arrow keys
										if (
											e.key === "ArrowUp" ||
											e.key === "ArrowDown"
										) {
											e.preventDefault();
										}
									}}
									maxLength={7}
									onWheel={(e) => e.target.blur()} //prevent mouse scroll bar action
									onInput={(e) => {
										if (e.target.value.length > 7) {
											e.target.value =
												e.target.value.slice(0, 7);
										}
									}}
									disabled={
										!props.isEnrollVessel &&
										props.vesselMstId &&
										(props?.regulations?.trim() ===
											"EUMRV" ||
											"UKMRV" ||
											"DCS")
									}
								/>
							)}
						/>
						{errors?.vesselAttributes?.pwind && (
							<div className="error-msg">
								{errors.vesselAttributes.pwind.message}
							</div>
						)}
					</MDBCol>

					<MDBCol md="12" className="mt-3">
						<Label
							bold
							name="P(prop), ship propulsion power (kW)"
							className="mb-1"
						/>
						<Controller
							name="vesselAttributes.pprop"
							control={control}
							defaultValue={
								props.vesselMstId &&
									props.vesselData?.Pprop !== null &&
									props.vesselData?.Pprop !== undefined
									? roundOff(props.vesselData.Pprop)
									: ""
							}
							render={({ field }) => (
								<Input
									id="vessel_prop"
									autoFocus={false}
									value={field.value}
									onChange={field.onChange}
									type="number"
									className="input-height"
									step={INPUT_STEP_VALUE}
									onBlur={(e) =>
										handleBlur(field.name, field.value)
									}
									maxLength={7}
									onKeyDown={(e) => {
										preventScientificNotation(e);
										// Prevent up and down arrow keys
										if (
											e.key === "ArrowUp" ||
											e.key === "ArrowDown"
										) {
											e.preventDefault();
										}
									}}
									onWheel={(e) => e.target.blur()} //prevent mouse scroll bar action
									onInput={(e) => {
										if (e.target.value.length > 7) {
											e.target.value =
												e.target.value.slice(0, 7);
										}
									}}
									disabled={
										!props.isEnrollVessel &&
										props.vesselMstId &&
										(props?.regulations?.trim() ===
											"EUMRV" ||
											"UKMRV" ||
											"DCS")
									}
								/>
							)}
						/>
						{errors?.vesselAttributes?.pprop && (
							<div className="error-msg">
								{errors.vesselAttributes.pprop.message}
							</div>
						)}
					</MDBCol>
				</MDBRow>
			</div>
		</>
	);
};

export default WapsFormGroup;
